/* eslint-disable max-len */
/* eslint-disable no-console */
import React from 'react';
import { Grid, Box, Typography, IconButton, Tooltip } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { MdOutlineRadioButtonUnchecked } from 'react-icons/md';

export 	const renderComp = (type, slctdFolder, uploadedFiles, handleFolder) =>
{
	const checkSlctd = uploadedFiles?.filter((media) => media?.tab === 0)?.some((selected) => selected?.name === slctdFolder?.media?.name);
	const renderSlctdImg = () =>
	{
		return (
			<Box
				sx={{
					position : 'absolute',
					top      : 2,
					right    : 2
				}}
			>
				<Box
					component='img'
					src='/images/icons/CheckImg.svg'
					alt='check_icon'
					sx={{ width: 'var(--pixel20)', height: 'var(--pixel20)' }}
				/>
			</Box>
		);
	};

	const renderCircle = () =>
	{
		return (
			<Box
				sx={{
					position : 'absolute',
					top      : 2,
					right    : 2
				}}
			>
				<MdOutlineRadioButtonUnchecked
					style={{ fontSize     : '20px',
						color        : '#737373',
						boxShadow    : '0px 2px 4px rgba(0, 0, 0, 0.4)',
						borderRadius : '50%'

					}}
				/>
			</Box>
		);
	};

	if (type === 'image')
	{
		return (
			<Grid item key={slctdFolder?._id} xs={12} sx={{ position: 'relative' }}>
				{!checkSlctd && renderCircle()}
				<button

					style={{
						width        : 'var(--percent100)',
						display      : 'inline-flex',
						borderRadius : 'var(--pixel8)',
						padding      : '0',
						overflow     : 'hidden',
						aspectRatio  : '4 / 3',
						border       : ' 1px solid var(--boxshadow0-5)'
					}}
				>
					<Box component='img' src={slctdFolder?.media?.url}
						alt={`img-${slctdFolder?._id}`}
						sx={{ width: 'var(--percent100)', borderRadius: 'var(--pixel8)', height: 'var(--percent100)', objectFit: 'contain' }}
					/>

					{checkSlctd && renderSlctdImg()}
				</button>
				<Box sx={{ width: 'var(--percent100)', overflow: 'hidden' }}>
					<Tooltip title={slctdFolder?.media?.name}>
						<Typography
							fontSize={14}
							sx={{
								whiteSpace   : 'nowrap',
								overflow     : 'hidden',
								textOverflow : 'ellipsis',
								width        : 'var(--percent100)',
								lineHeight   : 1.4
							}}
						>
							{slctdFolder?.media?.name}
						</Typography>
					</Tooltip>

				</Box>
			</Grid>
		);
	}
	else if (slctdFolder?.type === 0 || type === 'application')
	{
		const mediaExt = {
			image : 'jpg',
			video : 'mp4'
		};

		let extensionformat = slctdFolder?.media?.key?.split('.').pop();

		extensionformat = extensionformat || (mediaExt[type] || 'doc');

		return (
			<Grid item xs={12}>

				{slctdFolder?.type === 0
					? (
						<button
							onKeyUp={() => handleFolder(slctdFolder)}
							onClick={() => handleFolder(slctdFolder)}
							tabIndex={0} style={{
								width        : 'var(--percent100)',
								display      : 'inline-flex',
								borderRadius : 'var(--pixel8)',
								padding      : '0',
								overflow     : 'hidden',
								aspectRatio  : '4 / 3'
							}}
						>
							<img src='/images/icons/folder.svg' style={{ color: 'primary' }} alt='foldersicon' className='primaryTxt' />
						</button>)
					: (
						<>
							{!checkSlctd && renderCircle()}
							<LazyLoadImage
								src={`/documents/${extensionformat}.png`}
								alt='document'
								delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME} effect={process.env.REACT_APP_EFFECT} width={`${process.env.REACT_APP_IMG_WIDTH}%`} height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
							/>
							{checkSlctd && renderSlctdImg()}
						</>
					)}
				<Box sx={{ width: 'var(--percent100)', overflow: 'hidden' }}>
					<Tooltip title={slctdFolder?.media?.name || slctdFolder?.name}>
						<Typography
							fontSize={14}
							sx={{
								whiteSpace   : 'nowrap',
								overflow     : 'hidden',
								textOverflow : 'ellipsis',
								width        : 'var(--percent100)',
								lineHeight   : 1.2
							}}
						>
							{slctdFolder?.media?.name || slctdFolder?.name}
						</Typography>
					</Tooltip>

				</Box>
			</Grid>);
	}
	else
	{
		return (
			<Grid item sx={{ position: 'relative' }}>
				{!checkSlctd && renderCircle()}
				<video
					src={slctdFolder?.media?.url}
					width='var(--percent100)'
					height='var(--percent100)'
					style={{ objectFit: 'cover' }}
				/>

				<Box
					sx={{
						position        : 'absolute',
						top             : '45%',
						left            : 'var(--percent50)',
						transform       : 'translate(-50%, -50%)',
						zIndex          : 10,
						backgroundColor : 'rgba(0, 0, 0, 0.5)',
						borderRadius    : 'var(--percent50)',
						transition      : 'opacity 0.3s ease'
					}}
				>
					<IconButton
						sx={{
							color     : 'var(--whiteColor)',
							'&:hover' : { backgroundColor: 'transparent' }
						}}
						aria-label='play'
					>
						<PlayArrowIcon sx={{ fontSize: 16 }} />
					</IconButton>
				</Box>
				{checkSlctd && renderSlctdImg()}
				<Box sx={{ width: 'var(--percent100)', overflow: 'hidden' }}>
					<Tooltip title={slctdFolder?.media?.name}>
						<Typography
							fontSize={14}
							sx={{
								whiteSpace   : 'nowrap',
								overflow     : 'hidden',
								textOverflow : 'ellipsis',
								width        : 'var(--percent100)',
								lineHeight   : 1.2
							}}
						>
							{slctdFolder?.media?.name}
						</Typography>
					</Tooltip>

				</Box>
			</Grid>);
	}
};